import api from '@/api/api';

export default {
    listar() {
        return api.get(route('notifications'));
    },

    listarNaoLidas() {
        return api.get(route('unread-notifications'));
    },

    contar() {
        return api.get(route('notifications.count'));
    },

    listarTodas(params = {}) {
        return api.get(route('notifications.all'), { params });
    },

    obter(notification) {
        return api.get(route('notification', { notification }));
    },

    ler(notification) {
        return api.post(route('notification.read', { notification }));
    }
};
